import controller from '../../Controller.js';

function ScrollToCenter(element) {
  function init() {
    return;
    var list = element.querySelector('ul');
    list.scrollLeft += 65;
    window.addEventListener('resize', (e) => {
    })
  }
  return {
    init: init
  }
}

controller.add('ScrollToCenter', ScrollToCenter);

export default ScrollToCenter;
